export default {
  getDataSearch: state => state.dataSearch,
  getDataSearchOther: state => state.dataSearchOther,
  getRouter: state => state.router,
}
